'use client';

import { type Component, type ComponentProps } from '../../types/component';
import { tv } from '../../utils/tv';
import { Divider } from '../divider/Divider';

const menuDividerClasses = { root: 'zds-menu-divider-root' } as const;

const menuDividerStyles = tv({
  base: [menuDividerClasses.root, 'col-span-3 my-1'],
});

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface MenuDividerBaseProps {}

type MenuDividerProps = ComponentProps<MenuDividerBaseProps, 'div'>;

type MenuDividerComponent = Component<MenuDividerBaseProps, 'div'>;

const MenuDivider: MenuDividerComponent = (props) => {
  const { className, ref, ...rest } = props;

  return (
    <Divider
      {...rest}
      ref={ref}
      isDecorative={false}
      className={menuDividerStyles({ className })}
    />
  );
};

MenuDivider.displayName = 'Menu.Divider';

export {
  MenuDivider,
  type MenuDividerProps,
  type MenuDividerBaseProps,
  menuDividerClasses,
};
